import { Ifilter } from "../../Interfaces/filter";
import { ICrearElemento, IEditElemento, IElementoOculto } from "../../Interfaces/hazard/IHazard";
import { fetchListVerificacion } from "../http-common";

const ElementoEstandar = "ElementoEstandar";

const ComboElementoEstandar = (request: Ifilter, controller = new AbortController()) => {
    return fetchListVerificacion.get(`${ElementoEstandar}/ComboElementoEstandar`, {
        params: request,
        signal: controller.signal,
    });
};
const ListarElementoEstandar=(request: Ifilter)=>{
    return fetchListVerificacion.post(`${ElementoEstandar}/ListarElementos`,request)
}
const CrearElemento=(request:ICrearElemento)=>{
    return fetchListVerificacion.post(`${ElementoEstandar}/CrearElemento`,request)
}
const EditarElemento=(request:IEditElemento)=>{
    return fetchListVerificacion.put(`${ElementoEstandar}/ActualizarElemento`,request)
}
const OcultarElemento=(request:IElementoOculto)=>{
    return fetchListVerificacion.put(`${ElementoEstandar}/OcultarElemento`,request)
}
const ElementoEstandarService = {
    ComboElementoEstandar,ListarElementoEstandar,CrearElemento,EditarElemento,OcultarElemento
}

export { ElementoEstandarService };